// extracted by mini-css-extract-plugin
export var border = "_1c-7";
export var brand = "_1c-s";
export var button = "_1c-k";
export var center = "_1c-9";
export var centered = "_1c-5";
export var closeButton = "_1c-b";
export var disabledWrapper = "_1c-l";
export var error = "_1c-o";
export var extraLarge = "_1c-4";
export var extraSmall = "_1c-1";
export var fill = "_1c-h";
export var footer = "_1c-g";
export var footerAction = "_1c-i";
export var footerButtons = "_1c-j";
export var header = "_1c-6";
export var headerWithClose = "_1c-c";
export var icon = "_1c-n";
export var info = "_1c-r";
export var inline = "_1c-8";
export var large = "_1c-3";
export var main = "_1c-d";
export var modal = "_1c-0";
export var neutral = "_1c-t";
export var noPadding = "_1c-f";
export var none = "_1c-u";
export var scrollable = "_1c-e";
export var small = "_1c-2";
export var success = "_1c-q";
export var tight = "_1c-m";
export var titleIcon = "_1c-a";
export var warn = "_1c-p";